import React from "react";

// Organic SVG blob for visual accents.
export default function DecorBlob({ color = "#73DCC6", className = "", style = {} }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
      pointerEvents="none"
    >
      <path
        fill={color}
        d="M45.7,-76.3C58.9,-69.3,69.2,-55.4,78.3,-40.8C87.4,-26.2,95.4,-10.8,92.5,3.3C89.6,17.4,75.8,30.3,64.2,43.2C52.6,56.1,43.2,69,30.3,75.2C17.4,81.4,1,80.9,-13.6,76.5C-28.2,72.1,-41.1,63.8,-53.4,53.4C-65.7,43.1,-77.4,30.7,-82.1,15.9C-86.8,1.1,-84.5,-16,-76.8,-30.3C-69.1,-44.6,-56,-56,-42.2,-62.8C-28.4,-69.6,-14.2,-71.8,1.4,-73.8C17,-75.8,32.5,-83.3,45.7,-76.3Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}
